import React from 'react';
import { FaServer, FaReact, FaMobileAlt, FaPaintBrush } from 'react-icons/fa'; // Importing icons
import './Skills.css';

const Skills = () => {
  return (
    <div className="skills-container">
      <h1>My Skills</h1>
      <div className="cards-wrapper">
        <div className="skill-card">
          <FaServer className="skill-icon" />
          <h2>Backend Developer</h2>
          <p>I build and maintain server-side logic, databases, and APIs using Python, PHP, and Node.js.</p>
        </div>

        <div className="skill-card">
          <FaReact className="skill-icon" />
          <h2>Frontend Developer</h2>
          <p>I create responsive and interactive web interfaces using HTML, CSS, JavaScript, and React.</p>
        </div>

        <div className="skill-card">
          <FaMobileAlt className="skill-icon" />
          <h2>Mobile App Developer</h2>
          <p>I develop cross-platform mobile apps using Flutter and Dart with a smooth and modern UI.</p>
        </div>

        <div className="skill-card">
          <FaPaintBrush className="skill-icon" />
          <h2>Graphics Design</h2>
          <p>I design creative logos, posters, and branding materials using tools like GIMP and Canva.</p>
        </div>
      </div>
    </div>
  );
};

export default Skills;
